import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { WINDOW } from '@sfcu/sfc-front-starter';

export const apiErrorInterceptor: HttpInterceptorFn = (req, next) => {
    const router = inject(Router);
    const window = inject(WINDOW);
    return next(req).pipe(
        catchError((error: HttpErrorResponse) => {
            const isErrorPage = router.url.includes('erreur-technique');
            const code = error.error?.erreur?.code;
            if (error.status === 404 && code === 'PAS_DE_RESILIATION_EN_COURS') {
                return throwError(() => error);
            }
            if (error.status === 403 && code === 'CLIENT_NON_AUTORISE') {
                return throwError(() => error);
            }
            if (error.status === 500 && code === 'ERREUR_TECHNIQUE' && (window.location.href.includes('retractation')
                || window.location.href.includes('suivi'))
            ) {
                return throwError(() => error);
            }
            if (!isErrorPage) {
                router.navigate(['erreur-technique']);
            }
            return throwError(() => error);
        })
    );
};
